import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { apiClient } from 'api/apiClient/apiClient'
import { Module } from 'types/modules'

export type ModuleGroup = { name: Module; submodules?: string[]; is_active_for_system?: boolean }

export const MODULES_QUERY_KEY = `modules`

export function useModules(systemId: number | undefined): UseQueryResult<ModuleGroup[]> {
  return useQuery({
    queryKey: [MODULES_QUERY_KEY, { system: systemId }],

    queryFn: () =>
      apiClient<ModuleGroup[]>(`modules`, {
        params: {
          system: systemId,
        },
      }),

    enabled: !!systemId,
  })
}
